module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interupt",
    attrs: {
      "id": "interupt"
    }
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "cell-content"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/compass.svg"),
      "width": "44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-20"
  }), _vm._v("\n      För att delta i tävlingen måste spelet använda din enhets platsinformation"), _c('br'), _vm._v(" "), _c('h6', [_c('u', {
    on: {
      "click": _vm.openTurnOn
    }
  }, [_vm._v("Läs steg för steg instruktioner för iOS och Android här!")]), _c('br'), _c('br'), _c('u', {
    on: {
      "click": _vm.laddaOmSida
    }
  }, [_vm._v("Ladda om sidan")]), _c('br'), _c('br')])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6d16528"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errupt.vue
// module id = 118
// module chunks = 0